import { OptionLike } from "helpers/OptionHelper";
import { BaseModel } from "./BaseModel";
import { ExemptionMotiveTypeData } from "./types";

export class ExemptionMotiveType extends BaseModel<ExemptionMotiveTypeData> {
	id: string;
	name: string;
	code: string;
	description: string;

	constructor(data: ExemptionMotiveTypeData) {
		super(data);
		this.id = data.id;
		this.name = data.name;
		this.code = data.code;
		this.description = data.description;
	}

	toOption = (): OptionLike & ExemptionMotiveType => {
		return { ...this, label: `${this.code} - ${this.name}`, value: this.id };
	};
}
